import React from 'react';
import { oneOf } from 'prop-types';
import classNames from 'classnames';
import { pathOr } from 'ramda';

import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { propTypes, DATE_TYPE_DATE } from '../../util/types';
import { getQuantity, txIsEnquired } from '../../util/transactions';
import {
  Avatar,
  BookingTimeInfo,
  Button,
  NamedLink,
  UserDisplayName,
} from '../../components';
import css from './InboxPage.module.css';
import AlertBadge from '../../components/AlertBadge';

export const InboxItemMobile = props => {
  const { unitType, type, tx, intl, stateData, messageNotRode } = props;
  const isEnquiry = txIsEnquired(tx);
  const { booking, customer, provider } = tx;
  const isOrder = type === 'order';
  const txProtectedData = tx.attributes.protectedData;
  const enquiryDate = txProtectedData.date;

  const otherUser = isOrder ? provider : customer;
  const otherUserDisplayName = <UserDisplayName user={otherUser} intl={intl} />;
  const isOtherUserBanned = otherUser.attributes.banned;

  const linkClasses = classNames(css.itemLink, {
    [css.bannedUserLink]: isOtherUserBanned,
  });

  const protectedData = pathOr({}, ['attributes', 'protectedData'], tx);
  const quantity = isEnquiry ? protectedData.quantity : getQuantity(tx);
  const totalParticipants = quantity && quantity.adults
    ? parseInt(quantity.adults) + parseInt(quantity.children)
    : quantity;
  const quantityMessage = isEnquiry ? (
    <FormattedMessage id={'InboxPage.quantity'} values={{ quantity: totalParticipants }} />
  ) : (
    <FormattedMessage id={'InboxPage.quantity'} values={{ quantity: quantity.total }} />
  );


  return (
    <div className={css.item}>
      <NamedLink
        className={linkClasses}
        name={'InboxPage'}
        params={{ id: tx.id.uuid }}
      >
        <div className={css.itemAvatar}>
          <Avatar user={otherUser} disableProfileLink />
        </div>
        <div className={css.itemInfoContainer}>
          <div className={classNames(css.itemUsername, stateData.nameClassName)}>
            {messageNotRode && (<AlertBadge />)}
            {otherUserDisplayName}
          </div>
          {booking || enquiryDate ? (
            <div className={classNames(css.bookingInfoWrapper, stateData.bookingClassName)}>
              <BookingTimeInfo
                bookingClassName={stateData.bookingClassName}
                tx={tx}
                intl={intl}
              />
              {quantityMessage}
            </div>
          ) : null}
          <div className={classNames(css.itemState, css.stateName, stateData.stateClassName)}>
            {stateData.state}
          </div>
        </div>
      </NamedLink>
    </div>
  );
};

InboxItemMobile.propTypes = {
  unitType: propTypes.bookingUnitType.isRequired,
  type: oneOf(['order', 'sale']).isRequired,
  tx: propTypes.transaction.isRequired,
  intl: intlShape.isRequired,
};

export const InboxItemDesktop = props => {
  const { unitType, type, tx, intl, stateData, onClick, messageNotRode } = props;
  const { booking, customer, provider } = tx;
  const isOrder = type === 'order';
  const txProtectedData = tx.attributes.protectedData;
  const enquiryDate = txProtectedData.date;

  const otherUser = isOrder ? provider : customer;
  const otherUserDisplayName = <UserDisplayName user={otherUser} intl={intl} />;
  const isOtherUserBanned = otherUser.attributes.banned;

  const linkClasses = classNames(css.itemLink, {
    [css.bannedUserLink]: isOtherUserBanned,
  });

  return (
    <div className={css.item}>
      <Button
        rootClassName={linkClasses}
        onClick={() => onClick(tx)}
      >
        <div className={css.itemAvatar}>
          <Avatar user={otherUser} disableProfileLink />
        </div>
        <div className={css.itemInfoContainer}>
          <div className={classNames(css.itemUsername, stateData.nameClassName)}>
            {messageNotRode && (<AlertBadge/>)}
            {otherUserDisplayName}
          </div>
          {booking || enquiryDate ? (
            <div className={css.bookingInfoWrapper}>
              <BookingTimeInfo
                bookingClassName={stateData.bookingClassName}
                tx={tx}
                intl={intl}
              />
            </div>
          ) : null}
          <div className={classNames(css.itemState, css.stateName, stateData.stateClassName)}>
            {stateData.state}
          </div>
        </div>
      </Button>
    </div>
  );
};

InboxItemDesktop.propTypes = {
  unitType: propTypes.bookingUnitType.isRequired,
  type: oneOf(['order', 'sale']).isRequired,
  tx: propTypes.transaction.isRequired,
  intl: intlShape.isRequired,
};



// WEBPACK FOOTER //
// ./src/containers/InboxPage/InboxItems.js